//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import { Button   } from '@mui/material';

// === COMPONENTS ===
import { SystemRestartDialog } from './components/SystemRestartDialog/SystemRestartDialog';

//#endregion

//-----------------------------------------------------------------
export function SystemRestartButton() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ is_dialog_open , setIsDialogOpen ] = useState( false );

  //#endregion

  //#region [STYLES]

  const _styles = {
    restart_button: {
      flex     : '1 1 23%' ,
      minWidth : '10rem'   ,
      margin   : '0.5rem'  ,
    }
  }

  const RESTART_BUTTON = {
    sx       : _styles.restart_button,
    variant  : 'contained' ,
    color    : 'primary'   ,
    onClick  : handleClick ,
    children : [ 'System Restart' ] ,
    name     : 'restart_system_btn',
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  async function handleClick() {
    //-----------------------------------------------------------------
    setIsDialogOpen( true );
  }

  //-----------------------------------------------------------------
  async function onClose() {
    //-----------------------------------------------------------------
    setIsDialogOpen( false );
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <>
        <SystemRestartDialog is_open={is_dialog_open} onClose={onClose} />
        <Button { ...RESTART_BUTTON } />
      </>
    )
  }

  //#endregion

  return display();
}